import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, inr } from "@/lib/api";
import Navbar from "@/components/Navbar";

function Pill({ status }) {
  const cls = status === "paid" ? "status-paid" : "status-unpaid";
  return <span className={`status-pill ${cls}`}>{status}</span>;
}

export default function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/invoices").then((r) => { setInvoices(r.data); setLoading(false); }); }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-10">
        <h1 className="text-3xl font-heading font-semibold tracking-tight mb-6" data-testid="invoices-title">Invoices</h1>
        <div className="border border-gray-200">
          <div className="grid grid-cols-12 px-4 py-3 bg-gray-50 border-b border-gray-200 text-xs uppercase tracking-wider text-gray-600 font-medium">
            <div className="col-span-4">Invoice #</div>
            <div className="col-span-3">Date</div>
            <div className="col-span-2">Status</div>
            <div className="col-span-2 text-right">Amount</div>
            <div className="col-span-1"/>
          </div>
          {loading ? <div className="p-6 text-sm text-gray-500">Loading…</div> :
           invoices.length === 0 ? <div className="p-8 text-sm text-gray-500" data-testid="invoices-empty">No invoices.</div> :
           invoices.map((inv) => (
            <Link key={inv.id} to={`/invoices/${inv.id}`} className="grid grid-cols-12 px-4 py-4 border-b border-gray-100 hover:bg-gray-50 items-center" data-testid={`invoice-row-${inv.id}`}>
              <div className="col-span-4 font-medium text-sm">{inv.zoho?.zoho_invoice_number || `#${inv.id.slice(-8)}`}</div>
              <div className="col-span-3 text-sm text-gray-500">{new Date(inv.created_at).toLocaleString()}</div>
              <div className="col-span-2"><Pill status={inv.status} /></div>
              <div className="col-span-2 text-right text-sm font-medium">{inr(inv.total)}</div>
              <div className="col-span-1 text-right text-xs text-[#002fa7]">View</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
